import { View, Text, styled, ScrollView } from 'tamagui'
import { useAppStore, useServerStore } from '@/store'
import { ServerCard } from './ServerCard'

const Grid = styled(View, {
  padding: 24,
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: 16,
  // @ts-expect-error -- web grid
  style: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: 16,
  },
})

const EmptyState = styled(View, {
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
  padding: 48,
})

export function YourServersGrid() {
  const { serverOrder } = useServerStore()
  const { navigateToServer, setActiveChannel } = useAppStore()
  const servers = useServerStore((s) => s.servers)

  const handleServerClick = (serverId: string) => {
    const server = servers[serverId]
    navigateToServer(serverId)
    const firstText = server?.channels.find(c => c.type === 'text')
    if (firstText) setActiveChannel(firstText.id)
  }

  if (serverOrder.length === 0) {
    return (
      <EmptyState>
        <Text fontSize={40} marginBottom={16} opacity={0.3}>◈</Text>
        <Text fontFamily="$fontBody" fontSize={16} color="$sidebarMuted" textAlign="center">
          No servers yet. Create one or explore public servers!
        </Text>
      </EmptyState>
    )
  }

  return (
    <ScrollView flex={1} showsVerticalScrollIndicator={false}>
      <Grid>
        {serverOrder.map((id) => (
          <ServerCard key={id} serverId={id} onPress={() => handleServerClick(id)} />
        ))}
      </Grid>
    </ScrollView>
  )
}
